export const PROJECT_WORKSPACE_CONFIG = {
  solarentOperator: {
    roleKey: "SolarentOperator",
    source: "SolarentOperator",
    assignmentSource: "SolarentOperator",
    basePath: "/SLN/SolarentOperator/ProjectWorkspace",
    listPaths: {
      checkNew: "/SLN/SolarentOperator/CheckNewRequest",
      inProcess: "/SLN/SolarentOperator/InProcessRequest",
      allRequests: "/SLN/SolarentOperator/AllRequests",
    },
    detailApi: "SLN/SolarentOperator/AllRequests",
    historyApi: "SLN/SolarentOperator/CheckNewRequest",
    checkNewApi: "SLN/SolarentOperator/CheckNewRequest",
    orchestratorLinks: {
      finalApproval: "/SLN/SolarentOperator/ProjectFinalApproval",
      executionActivation: "/SLN/SolarentOperator/ProjectExecutionActivation",
      executionPlan: "/SLN/SolarentOperator/ProjectExecutionPlan",
      paymentActivation: "/SLN/SolarentOperator/ProjectPaymentActivation",
      procurementActivation: "/SLN/SolarentOperator/ProjectProcurementActivation",
      milestoneCoordination: "/SLN/SolarentOperator/ProjectMilestoneCoordination",
    },
  },
  management: {
    roleKey: "Management",
    source: "Management",
    assignmentSource: "Management",
    basePath: "/SLN/Management/ProjectWorkspace",
    listPaths: {
      checkNew: "/SLN/Management/CheckNewRequest",
      inProcess: "/SLN/Management/InProcessRequest",
      allRequests: "/SLN/Management/AllRequests",
    },
    detailApi: "SLN/Management/AllRequest",
    historyApi: "SLN/Management/CheckNewRequest",
    checkNewApi: "SLN/Management/CheckNewRequest",
    orchestratorLinks: {
      finalApproval: "/SLN/Management/ProjectFinalApproval",
      executionActivation: "/SLN/Management/ProjectExecutionActivation",
      executionPlan: "/SLN/Management/ProjectExecutionPlan",
      paymentActivation: "/SLN/Management/ProjectPaymentActivation",
      procurementActivation: "/SLN/Management/ProjectProcurementActivation",
      milestoneCoordination: "/SLN/Management/ProjectMilestoneCoordination",
    },
  },
};

export const WORKSPACE_SECTIONS = [
  { id: "overview", label: "خلاصه و Timeline" },
  { id: "initial-review", label: "بررسی اولیه" },
  { id: "loan-mehrsan", label: "وام / مهرسان" },
  { id: "operational", label: "برنامه عملیاتی و ارجاع" },
  { id: "visit", label: "بازدید و گزارش ناظر" },
  { id: "quotes-contract", label: "هزینه پیمانکار و قیمت" },
  { id: "execution", label: "تایید نهایی و اجرا" },
  { id: "financial", label: "مالی / پرداخت" },
  { id: "files", label: "فایل‌ها و مستندات" },
  { id: "followups", label: "پیگیری‌ها" },
];
